/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Last_Refill_Messages_RechargedInputs */

const es_admin_billing_last_refill_messages_recharged = /** @type {(inputs: Admin_Billing_Last_Refill_Messages_RechargedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensajes recargados`)
};

const en_admin_billing_last_refill_messages_recharged = /** @type {(inputs: Admin_Billing_Last_Refill_Messages_RechargedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messages recharged`)
};

/**
* | output |
* | --- |
* | "Messages recharged" |
*
* @param {Admin_Billing_Last_Refill_Messages_RechargedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_last_refill_messages_recharged = /** @type {((inputs?: Admin_Billing_Last_Refill_Messages_RechargedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Last_Refill_Messages_RechargedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_last_refill_messages_recharged(inputs)
	return en_admin_billing_last_refill_messages_recharged(inputs)
});
export { admin_billing_last_refill_messages_recharged as "admin.billing.last_refill.messages_recharged" }